import React from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { generatePath, useHistory, useParams } from "react-router-dom"

import { logOut, terminalLogout } from "../../actions/authentication"
import { Routes } from "../../constants/routes"
import { OIDC_LOGOUT_URL } from "../../oidcConfig"
import { getUserData } from "../../sagas/selectors"

const Logout = React.memo(() => {
  const { userId, token } = useSelector(getUserData, shallowEqual)
  const dispatch = useDispatch()
  const { terminal } = useParams()
  const history = useHistory()
  const hasTerminalId = terminal && terminal !== ":terminal"
  const has2FA = useSelector(state => state.globalsettings.settings.hasTwoFactorAuthentication)

  if (has2FA) {
    window.location.replace(OIDC_LOGOUT_URL)
  }

  if (hasTerminalId && userId) {
    dispatch(terminalLogout(terminal, userId, token))
  } else if (userId) {
    dispatch(logOut(userId, token))
  } else if (hasTerminalId) {
    history.push(generatePath(Routes.TERMINAL_START, { terminalId: terminal }))
  } else {
    history.push(Routes.LOGIN)
  }
  return null
})

export default Logout
